import React, { useState, useEffect } from 'react';
import { VStack, Stack, Button } from '@chakra-ui/react';
import { useCharacter } from '../Contexts/CharacterInfo.js';
import WeaponDialog from './WeaponDialog';
import { FaPlus } from 'react-icons/fa';
import GearDisplay from './GearDisplay';

const GearContent = () => {
  const { character } = useCharacter();
  const [isSideWeapon, setIsSideWeapon] = useState(false);
  const [isEquipment, setIsEquipment] = useState(false);
  const [isWeaponOpen, setIsWeaponOpen] = useState(false);
  const [hideSideWeapon, setHideSideWeapon] = useState(false);
  const [primaryWeapon, setPrimaryWeapon] = useState(null);
  const [secondaryWeapon, setSecondaryWeapon] = useState(null);
  const [equipment, setEquipment] = useState(null);
  const handleAddWeapon = () => setIsWeaponOpen(true);

  const closeWeaponDialog = () => {
    setIsWeaponOpen(false);
    setIsSideWeapon(false);
    setIsEquipment(false);
  };

  useEffect(() => {
    setPrimaryWeapon(null);
    setSecondaryWeapon(null);
    setEquipment(null);

    if (character.primaryWeaponId) {
      const primaryWeapon = character.storage.find(
        gear => gear.id === character.primaryWeaponId
      );
      setPrimaryWeapon(primaryWeapon);
      if (primaryWeapon && primaryWeapon.isOversized) setHideSideWeapon(true);
    }
    if (character.secondaryWeaponId) {
      const secondaryWeapon = character.storage.find(
        gear => gear.id === character.secondaryWeaponId
      );
      setSecondaryWeapon(secondaryWeapon);
    }
    if (character.equipmentId) {
      const equipment = character.storage.find(
        gear => gear.id === character.equipmentId
      );
      setEquipment(equipment);
    }
  }, [
    character.primaryWeaponId,
    character.secondaryWeaponId,
    character.equipmentId,
    character.storage,
  ]);

  return (
    <Stack
      justify="center"
      align="center"
      direction={{ base: 'column', md: 'column', lg: 'row' }}
      spacing={10}
    >
      <VStack align="center" justify="center">
        <b>Primary Weapon</b>
        {primaryWeapon === null && (
          <Button height={'120px'} width={'150px'} onClick={handleAddWeapon}>
            <FaPlus size={50} />
          </Button>
        )}
        {primaryWeapon != null && <GearDisplay gear={primaryWeapon} />}
      </VStack>
      {!hideSideWeapon && (
        <VStack align="center" justify="center">
          <b>Side Arm</b>
          {secondaryWeapon === null && (
            <Button
              height={'120px'}
              width={'150px'}
              onClick={() => {
                setIsSideWeapon(true);
                handleAddWeapon();
              }}
            >
              <FaPlus size={50} />
            </Button>
          )}
          {secondaryWeapon != null && (
            <GearDisplay gear={secondaryWeapon} isSideWeapon={true} />
          )}
        </VStack>
      )}
      <VStack align="center" justify="center">
        <b>Equipment</b>
        {equipment === null && (
          <Button
            height={'120px'}
            width={'150px'}
            onClick={() => {
              setIsEquipment(true);
              handleAddWeapon();
            }}
          >
            <FaPlus size={50} />
          </Button>
        )}
        {equipment != null && (
          <GearDisplay gear={equipment} isEquipment={true} />
        )}
      </VStack>
      <WeaponDialog
        isOpen={isWeaponOpen}
        isSideWeapon={isSideWeapon}
        isEquipment={isEquipment}
        onClose={closeWeaponDialog}
      />
    </Stack>
  );
};

export default GearContent;
